import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["aria-controls", "aria-selected", "onClick", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($props.wrapperClass),
    id: $props.id
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.navWrapperClass)
    }, [
      _renderSlot(_ctx.$slots, "header"),
      _createElementVNode("ul", {
        role: "tablist",
        class: _normalizeClass($props.navClass)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.tabs, (tab, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            class: _normalizeClass([tab.navItemClass ?? $props.navItemClass,tab.isDisabled ? $props.navItemDisabledClass : '', tab.isActive ? $props.navItemActiveClass : (!tab.isDisabled ? $props.navItemInactiveClass : '')]),
            role: "presentation"
          }, [
            _createElementVNode("button", {
              type: "button",
              role: "tab",
              class: _normalizeClass([tab.navItemLinkClass ?? $props.navItemLinkClass, tab.isDisabled ? $props.navItemLinkDisabledClass : '', tab.isActive ? $props.navItemLinkActiveClass : (!tab.isDisabled ? $props.navItemLinkInactiveClass : '') ]),
              "aria-controls": tab.paneId,
              "aria-selected": tab.isActive,
              onClick: ($event: any) => ($setup.selectTab(tab.hash, $event)),
              innerHTML: tab.header,
              tabindex: "0"
            }, null, 10, _hoisted_2)
          ], 2))
        }), 128))
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass($props.panelsWrapperClass)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 10, _hoisted_1))
}